<template>
  <div  style=" display:flex;height: 100%;">
    <template v-if="hasSims">
      <div v-if="leftNav.length" class="tab-next">
<!--        <el-tabs v-model="fixedId" :tab-position="tabPosition" @tab-click="handleChangeFixed">-->
<!--          <el-tab-pane v-for="item in leftNav" :key="item.idx" :label="item.name" :name="item.idx"></el-tab-pane>-->
<!--        </el-tabs>-->
        <div v-for="item in leftNav" :key="item.id" @click="handleChangeFixed(item.idx)" class="tabTag" :class="{activeTabTag:fixedId == item.idx}"> {{item.name}}</div>
      </div>
      <div style="flex:1;padding:0 15px;display: flex;flex-direction: column;width: 1px;">
        <div class="fileTitle">基准文件</div>
        <div
            style="display: flex;flex-direction: column;flex:1;height: 1px;border:1px solid #DCDFE6;margin-top: 16px;border-radius: 5px;">
          <div
              style="background: #E5E6EB;height: 40px;line-height: 40px;padding-left: 20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-weight: bold;color: #000;">
            <span>{{ showData.name }}/{{ showData.mulu }}</span>  <span style="color: #d9001b;margin-left: 20px;">图片所在第{{basePage}}页</span>
          </div>
          <div
              style="flex:1;height: 1px;display: flex;justify-content: center;align-items: center;"
          >
            <img :src="baseUrl" alt="" style="max-height: 100%;max-width: 100%;">
          </div>
        </div>
      </div>
      <div style="width: 100px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <img src="@/assets/image/imageSimilar.png" alt="">
        <span style="color: #1D2129;font-size: 20px;font-weight: bold;">{{similarVal}}%</span>
        <span>相似度</span>
      </div>
      <div style="flex: 1;padding:0 15px;display: flex;flex-direction: column;width: 1px;">
        <div class="fileTitle">目标文件</div>
        <div
            style="display: flex;flex-direction: column;flex:1;height: 1px;border:1px solid #DCDFE6;margin-top: 16px;border-radius: 5px;">
          <div
              style="background: #E5E6EB;height: 40px;line-height: 40px;padding-left: 20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-weight: bold;color: #000;">
            <span>{{ showData.cont_name }}/{{ showData.cont_mulu }} </span><span style="color: #d9001b;margin-left: 20px;">图片所在第{{contPage}}页</span>
          </div>
          <div
              style="flex:1;height: 1px;display: flex;justify-content: center;align-items: center;"
          >
            <img :src="contUrl" alt="" style="max-height: 100%;max-width: 100%;">
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="aaa"
           style="height: 100%;width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <img alt="" src="@/assets/image/empty.png">
        <div style="margin-top: 10px;">没有该文件组合的对比结果，请重新选择</div>
      </div>
    </template>

  </div>
</template>

<script>
export default {
  name: "imgCmp",
  props: {
    contId: {
      type: String,
      required: true
    },
    baseId: {
      type: String,
      required: true
    },
    showData: {
      type: Object,
      required: true
    },
    imageData: {
      type: Object,
      required: true
    }
  },
  data(){
    return {
      leftNav:[],
      tabPosition: 'left',
      fixedId:0,
      baseUrl: "",
      basePage:"",
      contUrl: "",
      contPage:"",
      similarVal:"",
      currentData:{},
      hasSims:true
    }
  },
  mounted() {
    this.init()
  },
  methods:{
    init(){
      this.filterNav();
    },
    filterNav(){
      this.leftNav = [];
      const idx = `${this.baseId}-${this.contId}`;
      let leftId = this.imageData[idx];
      if(leftId?.length){
        leftId.forEach((val,key)=>{
          this.leftNav.push({
            name:`相似项${key+1}`,
            idx:String(key),
            ...val
          })
        })
        this.fixedId ="0";
        this.hasSims = true;
        this.handleChangeFixed(this.fixedId);
      }else{
          this.hasSims = false;
      }
    },
    handleChangeFixed(idx){
      this.fixedId = idx;
      let temp = this.$_.filter(this.leftNav, (item) => {
        return item.idx == this.fixedId;
      });
      this.currentData = temp.length ? temp[0] : {};
      this.basePage = this.getPage(this.currentData.stdPath);
      this.contPage = this.getPage(this.currentData.compPath);
      this.baseUrl = this.currentData.stdPath;
      this.contUrl = this.currentData.compPath;
      this.similarVal = this.currentData.similarVal?(this.currentData.similarVal*100).toFixed(2):0;
      this.$Jquery('.activeTabTag')[0]?.scrollIntoView({behavior:"smooth",block:"center"});
    },
    getPage(str){
      let arr = str.split("\\");
      let fileName = arr[arr.length-1];
      let arr1 = fileName.split("_");
      let pageName = arr1[arr1.length-1];
      return pageName.slice(0,-4);

    },
  },
  watch: {
    showData: {
      handler() {
        this.init();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tab-next {
  max-width: 150px;
  flex: 1;
  height: 100%;
  overflow-y: auto;
  .tabTag{
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .activeTabTag{
    color: #409EFF !important;
    position: relative;
    &::after{
      display: block;
      content: "";
      width: 2px;
      background: #409EFF;
      position: absolute;
      height: 20px;
      top:5px;
      right: 10px;
    }
  }

}
</style>
